import { useSetRecoilState } from 'recoil'

import { manageMenuStore, ManageMenuStoreType } from './useManageMenuStore'

const useManageMenuAction = () => {
    const setManageMenuStore = useSetRecoilState(manageMenuStore)

    const setState = (newState: Partial<ManageMenuStoreType>) => {
        setManageMenuStore((prevState) => ({
            ...prevState,
            ...newState,
        }))
    }

    const setIsOpen = (param?: boolean) => {
        setManageMenuStore((prevState) => ({
            ...prevState,
            isOpen: param,
        }))
    }

    const clearStore = () => {
        setManageMenuStore((prevState) => ({
            ...prevState,
            isOpen: null,
        }))
    }
    return { setState, setIsOpen, clearStore }
}

export default useManageMenuAction
